var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTypeleftDown = function SvgTypeleftDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.747 18.53a.5.5 0 0 0-.497-.449H6.707L18.935 5.854a.497.497 0 0 0 0-.708.499.499 0 0 0-.707 0L6 17.374V7.831a.5.5 0 0 0-1 0v10.75a.5.5 0 0 0 .5.5h10.75a.5.5 0 0 0 .497-.55Z",
    fill: "currentColor"
  })));
};
export { SvgTypeleftDown as ReactComponent };
export default __webpack_public_path__ + "2fa7947c8e3ed1219fbd2bb81fc05cd4.svg";